<template lang="pug">
  footer.footer.bg-xl-blue
    p.footer__logo-text.clr-d-blue Разработано компанией

    a.footer__logo.clr-d-blue(
      href=`https://em-engin.ru/`
      target=`_blank`
    )
      svg.clr-d-blue(xmlns=`http://www.w3.org/2000/svg`)
        use(:href="$setSvgHref(`img/sprite.svg#i-logo`)")

    .footer__contacts
      .footer__block
        p.footer__text.clr-black 194214, Санкт-Петербург, проспект Энгельса, д. 71, оф 200
        a(href=`tel:+78123317576`).footer__text.clr-black.t-tdn +7 (812) 331-75-76

      .footer__block
        p.footer__text.clr-black Единая справочная служба
        a(href=`tel:88005507506`).footer__text.clr-black.t-tdn 8 800 550-75-06

      .footer__block
        a(href=`mailto:info@euroml.ru`).footer__text.clr-black.t-tdn info@euroml.ru
        a(href=`https://em-engin.ru`).footer__text.clr-black.t-tdn em-engin.ru

    a(href=`https://em-engin.ru/politika-konfidentsialnosti/` target=`_blank`).footer__policy.clr-black.t-tdn Политика конфиденциальности

    p.footer__copyrights.clr-black Разработка сайта — #[a.clr-black.t-tdn(href=`//its.agency` target=`_blank`) its.agency]

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .footer {
    display: grid;
    grid-template-columns: 48.5vw auto;
    grid-template-areas:
      'logo-text ..........'
      'logo        contacts'
      'policy    copyrights';
    width: 100%;
    padding-top: 4rem;
    padding-bottom: 2.5rem;
    padding-left: $offset-desktop;
    padding-right: $offset-desktop;

    @include respond-max(tablet) {
      grid-template-columns: 100%;
      grid-template-areas:
        'logo-text'
        'logo'
        'contacts'
        'policy'
        'copyrights';
      }
  }

  .footer__logo-text {
    grid-area: logo-text;
    margin-bottom: 1.125rem;
    font-size: 1.5rem;
    opacity: 0.7;
  }

  .footer__logo {
    grid-area: logo;
    margin-bottom: 8.75rem;
    @include font('m');
    font-size: 2.4rem;
    line-height: 1.1;
    white-space: nowrap;
    text-decoration: none;
    transition: $trs;

    svg {
      width: 17.25rem;
      height: 3rem;
    }

    &:hover {
      opacity: 0.8;
    }

    @include respond-max(tablet) {
      margin-bottom: 4rem;
      font-size: 2rem;
    }
  }

  .footer__contacts {
    grid-area: contacts;
    margin-bottom: 8.75rem;
    font-size: 1.125rem;

    @include respond-max(tablet) {
      margin-bottom: 4rem;
    }
  }

  .footer__block {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 2.5rem;
    padding-bottom: 2.5rem;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 2.5rem;
      height: 1px;
      background-color: $l-blue;
    }

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;

      &::after {
        display: none;
      }
    }
  }

  .footer__text {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    &[href] {
      transition: $trs;

      &:hover {
        color: rgba($black, 0.8);
      }
    }
  }

  .footer__policy {
    grid-area: policy;
    justify-self: flex-start;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba($black, 0.4);
    transition: $trs;

    &:hover {
      border-bottom-color: $black;
    }

    @include respond-max(tablet) {
      margin-bottom: 2rem;
    }
  }

  .footer__copyrights {
    grid-area: copyrights;

    a {
      @include font('m');
      transition: $trs;

      &:hover {
        color: $blue;
      }
    }
  }
</style>
